import axios from '@/plugins/axios'
import {getViewToken, getViewUser} from '@/util/viewAuth'

function withAuthHeaders(token = getViewToken()) {
	return token ? {Authorization: token} : {}
}

function safeTotal(pageInfo) {
	if (!pageInfo || typeof pageInfo !== 'object') {
		return 0
	}
	return Number(pageInfo.total || 0)
}

function flattenComments(tree = [], result = [], limit = 10) {
	for (let i = 0; i < tree.length; i++) {
		const item = tree[i]
		if (result.length >= limit) {
			return result
		}
		result.push(item)
		if (item.replyComments && item.replyComments.length > 0) {
			flattenComments(item.replyComments, result, limit)
		}
	}
	return result
}

export function fetchMyMomentCount(token = getViewToken()) {
	return axios({
		url: 'admin/moments',
		method: 'GET',
		headers: withAuthHeaders(token),
		params: {
			pageNum: 1,
			pageSize: 1
		}
	}).then(res => safeTotal(res.data))
}

export function fetchMyCommentCount(token = getViewToken()) {
	return axios({
		url: 'admin/comments',
		method: 'GET',
		headers: withAuthHeaders(token),
		params: {
			page: 3,
			pageNum: 1,
			pageSize: 1
		}
	}).then(res => safeTotal(res.data))
}

export function fetchRecentMoments(token = getViewToken()) {
	return axios({
		url: 'moments',
		method: 'GET',
		headers: withAuthHeaders(token),
		params: {
			pageNum: 1
		}
	}).then(res => {
		const list = res.data && res.data.list ? res.data.list : []
		return list.slice(0, 6).map(item => ({
			id: item.id,
			content: item.content,
			createTime: item.createTime,
			likes: item.likes
		}))
	})
}

export function fetchRecentComments(token = getViewToken()) {
	return axios({
		url: 'admin/comments',
		method: 'GET',
		headers: withAuthHeaders(token),
		params: {
			page: 3,
			pageNum: 1,
			pageSize: 10
		}
	}).then(res => {
		const list = res.data && res.data.list ? res.data.list : []
		return flattenComments(list, [], 8).map(item => ({
			id: item.id,
			nickname: item.nickname,
			content: item.content,
			createTime: item.createTime,
			momentId: item.momentId || null
		}))
	})
}

export function fetchRecentLoginLogs(token = getViewToken()) {
	return axios({
		url: 'admin/loginLogs',
		method: 'GET',
		headers: withAuthHeaders(token),
		params: {
			pageNum: 1,
			pageSize: 5
		}
	}).then(res => {
		const page = res.data || {}
		return {
			total: safeTotal(page),
			list: page.list || []
		}
	})
}

export async function fetchUserCenterData() {
	const token = getViewToken()
	const user = getViewUser()
	const likes = JSON.parse(window.localStorage.getItem('likeMomentIds') || '[]')

	const [momentCountRes, commentCountRes, momentsRes, commentsRes, loginLogsRes] = await Promise.allSettled([
		fetchMyMomentCount(token),
		fetchMyCommentCount(token),
		fetchRecentMoments(token),
		fetchRecentComments(token),
		fetchRecentLoginLogs(token),
	])

	const momentCount = momentCountRes.status === 'fulfilled' ? momentCountRes.value : 0
	const commentCount = commentCountRes.status === 'fulfilled' ? commentCountRes.value : 0
	const recentMoments = momentsRes.status === 'fulfilled' ? momentsRes.value : []
	const recentComments = commentsRes.status === 'fulfilled' ? commentsRes.value : []
	const loginLogs = loginLogsRes.status === 'fulfilled' ? loginLogsRes.value : {total: 0, list: []}

	return {
		user,
		stats: {
			momentCount,
			commentCount,
			likeCount: likes.length,
			favoriteCount: 0,
			lastLoginTime: loginLogs.list[0] ? loginLogs.list[0].createTime : user.lastLoginTime
		},
		recent: {
			moments: recentMoments,
			comments: recentComments,
			likes: likes.slice(0, 8).map(id => ({id, label: `动态 #${id}`}))
		}
	}
}

export function updateAccountPassword(payload = {}, token = getViewToken()) {
	return axios({
		url: 'admin/account',
		method: 'POST',
		headers: withAuthHeaders(token),
		data: payload
	})
}

export function uploadUserAvatar(file, token = getViewToken()) {
	const formData = new FormData()
	formData.append('file', file)
	return axios({
		url: 'admin/uploadMedia',
		method: 'POST',
		headers: withAuthHeaders(token),
		data: formData
	})
}
